/**
 * Sparse Date × Ticket matrix: each date belongs to one ticket, and each
 * ticket belongs to one date. Picking either option selects the other and
 * attaches that variant before product-swatch emits variant:change.
 */
(() => {
  if (window.__mcfMasterclassSync) return;
  window.__mcfMasterclassSync = true;

  function findVariant(variants, key, value) {
    const matches = variants.filter((variant) => variant[key] === value);
    return matches.find((variant) => variant.available !== false) || matches[0] || null;
  }

  function writeVariant(swatch, input, match, productUrl) {
    const fetchURL = `${productUrl}?variant=${match.id}`;
    input.setAttribute('data-product-fetch-url', fetchURL);
    input.setAttribute('data-product-url', productUrl);

    const swatchEl = input.closest('.swatch-element');
    if (swatchEl) {
      swatchEl.setAttribute('data-swatch-variant-id', String(match.id));
      swatch.querySelectorAll('.swatch-element').forEach((el) => el.classList.remove('active'));
      swatchEl.classList.add('active');
    }

    let script = swatch.querySelector(`script[type="application/json"][data-resource="${input.id}"]`);
    if (!script) {
      script = document.createElement('script');
      script.type = 'application/json';
      script.setAttribute('data-resource', input.id);
      (swatchEl || swatch).appendChild(script);
    }
    script.textContent = JSON.stringify(match);
  }

  function selectOption(root, optionIndex, value, match, productUrl) {
    const swatch = root.querySelector(`product-swatch[data-option-index="${optionIndex}"]`);
    if (!swatch || !value) return;

    const input = Array.from(swatch.querySelectorAll('input[data-product-variant][type="radio"]')).find(
      (el) => el.value === value
    );
    if (!input) return;

    input.checked = true;
    writeVariant(swatch, input, match, productUrl);
  }

  document.addEventListener(
    'change',
    (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.matches('input[data-product-variant][type="radio"]')) return;

      const root = input.closest('[data-masterclass-option-sync]');
      if (!root) return;

      const variantsEl = root.querySelector('[data-masterclass-variants]');
      if (!variantsEl) return;

      let variants = [];
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (e) {
        return;
      }

      const swatch = input.closest('product-swatch');
      const optionIndex = swatch?.getAttribute('data-option-index');
      if (optionIndex !== '0' && optionIndex !== '1') return;

      const match =
        optionIndex === '0'
          ? findVariant(variants, 'option1', input.value)
          : findVariant(variants, 'option2', input.value);
      if (!match) return;

      const productUrl = root.getAttribute('data-product-url') || variantsEl.getAttribute('data-product-url') || '';
      writeVariant(swatch, input, match, productUrl);

      if (optionIndex === '0') {
        selectOption(root, '1', match.option2, match, productUrl);
      } else {
        selectOption(root, '0', match.option1, match, productUrl);
      }
    },
    true
  );
})();
